/**
 * Добавление на страницу с формой 2 малозаметных точек, для получения в консоль данных формы и тела запроса создания
 * @param {}
 * @return {}
 */
import React from "react";
import { Tooltip } from "antd";
import { combineClasses } from "../../../lib/utils/combineClasses";
import "./FormInfo.less";

interface ComponentProps {
  className?: string;
  getFormValues?: () => any;
  getCreateBody?: () => any;
  getCreateBodyAsync?: () => Promise<any>;
}

export const FormInfo = (props: ComponentProps) => {
  const { className, getCreateBody, getFormValues, getCreateBodyAsync } = props;

  const logFormValues = () => {
    if (getFormValues) {
      const values = getFormValues();
      console.log(values);
    }
  };

  const logCreateBodyValues = async () => {
    if (getCreateBody) {
      const values = getCreateBody();
      console.log(values);
    } else if (getCreateBodyAsync) {
      const values = await getCreateBodyAsync();
      console.log(values);
    }
  };

  return (
    <div className={combineClasses("form-info", className)}>
      {getFormValues && (
        <div className="form-info__item" onClick={logFormValues}>
          <Tooltip title="form values">.</Tooltip>
        </div>
      )}
      {(getCreateBody || getCreateBodyAsync) && (
        <div className="form-info__item" onClick={logCreateBodyValues}>
          <Tooltip title="create body values">.</Tooltip>
        </div>
      )}
    </div>
  );
};
